const CardTitle = ({ value }) => (
  <div className="font-montserrat text-lg text-224E73 p-4 bg-E2E2E2">
    {value}
  </div>
);

export default CardTitle;
